<style>
</style>
<template>
  <admin-layout>
    <template v-slot:breadcrumb>
      <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
        <li class="breadcrumb-item text-sm">
          <a class="opacity-5 text-white" href="javascript:;">Admin</a>
        </li>
        <li class="breadcrumb-item text-sm text-white" aria-current="page">
          Perfil
        </li>
      </ol>
    </template>

    <template v-slot:header>
      <h5 class="font-weight-bolder text-white mt-4 mb-0">Editar Perfil</h5>
    </template>

    <template #content>
      <div class="row">
        <form @submit.prevent="update">
          <div class="col-12">
            <div class="card">
              <div class="card-header pb-0"></div>
              <div class="card-body">
                <p class="text-uppercase text-sm">Informações</p>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="example-text-input" class="form-control-label"
                        >Nome</label
                      >
                      <input
                        class="form-control"
                        type="text"
                        v-model="form.name"
                        onfocus="focused(this)"
                        onfocusout="defocused(this)"
                        :class="{ 'is-invalid': form.errors.name }"
                      />
                    </div>
                    <div
                      class="invalid-feedback mb-3"
                      :class="{ 'd-block': form.errors.name }"
                    >
                      {{ form.errors.name }}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="example-text-input" class="form-control-label"
                        >E-mail</label
                      >
                      <input
                        class="form-control"
                        type="email"
                        v-model="user.email"
                        onfocus="focused(this)"
                        onfocusout="defocused(this)"
                        :class="{ 'is-invalid': form.errors.email }"
                      />
                    </div>
                    <div
                      class="invalid-feedback mb-3"
                      :class="{ 'd-block': form.errors.email }"
                    >
                      {{ form.errors.email }}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="example-text-input" class="form-control-label"
                        >Senha</label
                      >
                      <input
                        class="form-control"
                        type="password"
                        v-model="form.password"
                        onfocus="focused(this)"
                        onfocusout="defocused(this)"
                        :class="{ 'is-invalid': form.errors.password }"
                      />
                    </div>
                    <div
                      class="invalid-feedback mb-3"
                      :class="{ 'd-block': form.errors.password }"
                    >
                      {{ form.errors.password }}
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="example-text-input" class="form-control-label"
                        >Confirmar Senha</label
                      >
                      <input
                        class="form-control"
                        type="password"
                        v-model="form.checkPassword"
                        onfocus="focused(this)"
                        onfocusout="defocused(this)"
                        :class="{ 'is-invalid': form.errors.password }"
                      />
                    </div>
                    <div
                      class="invalid-feedback mb-3"
                      :class="{ 'd-block': form.errors.password }"
                    >
                      {{ form.errors.password }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <button
                  v-if="form.password === form.checkPassword"
                  class="btn btn-primary"
                  @click="update"
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </template>
  </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";

export default {
  props: ["user"],
  components: {
    AdminLayout,
  },

  data() {
    return {
      editMode: false,

      form: this.$inertia.form({
        id: this.user.id,
        name: this.user.name,
        email: this.user.email,
        password: "",
        checkPassword: "",
        //role: this.user.role,
      }),
    };
  },

  methods: {
    update() {
      this.form.patch(this.route("admin.profile.update", this.form), {
        preserveScroll: true,
        onSuccess: () => {
          /* this.closeModal(); */
          /*  this.form.reset(); */
        },
      });
    },
  },

  mounted() {},
};
</script>

